
/**
 * Feedback JS
 */

/* global biro_body */

jQuery( function( $ ) {

	// Feedback buttons
	biro_body.on( 'click', '.feedback-button', function() {

		// Init
		var $el = $( this );

		// Hide, then show appropriate response
		$( '.feedback-prompt' ).hide();
		$( '.feedback-' + $el.data( 'feedback' ) ).show();
		// For styling spinner
		//$( '#gform_submit_button_1' ).after('<img id="gform_ajax_spinner_1"  class="gform_ajax_spinner" src="https://gg-tacs.bureau.test/wp-content/themes/bureau-gg-tacs/assets/img/ajax-spinner.svg" alt="" />');

	});

});